import { blueGray30, blueGray54, white } from 'apps/new-web/views/themes/colors';

export const muiBtnStyle = {
  style: {
    marginTop: '40px',
    height: '40px'
  },
  label: {
    letterSpacing: '.03563em',
    padding: '22px',
    top: '-2px',
    display: 'inline-block',
    fontSize: '.875rem',
    color: blueGray30
  },
  dialogBtn: {
    width: '100%',
    height: '60px'
  },
  disabledBackgroundColor: blueGray30,
  disabledLabelColor: white
};

export const muiInputStyle = {
  style: {
    marginTop: '20px',
    color: blueGray54
  },
  error: {
    textAlign: 'left'
  }
};

export const muiDialogStyle = {
  actions: {
    width: '100%',
    padding: '0 55px 40px'
  },
  content: {
    maxWidth: '450px',
    textAlign: 'center'
  },
  mobileContent: {
    maxWidth: '100%',
    width: '100%',
    paddingBottom: '30px',
    textAlign: 'center'
  },
  body: {
    padding: '55px 55px 40px',
  }
};